/**
 * Taille de fichier lisible.
 *
 * Unites francaises, separateur decimal virgule, une decimale au-dela du
 * kilo-octet. Une taille inconnue s'affiche comme inconnue : pas de « 0 o » qui
 * ferait croire a un fichier vide.
 */
const KILO = 1024

export function formaterTaille(octets: number | null | undefined): string {
  if (octets === null || octets === undefined || !Number.isFinite(octets) || octets < 0) {
    return ''
  }

  if (octets < KILO) {
    return `${Math.round(octets)} o`
  }

  const enKilo = octets / KILO
  if (enKilo < KILO) {
    return `${arrondir(enKilo)} ko`
  }

  return `${arrondir(enKilo / KILO)} Mo`
}

function arrondir(valeur: number): string {
  return (Math.round(valeur * 10) / 10).toFixed(1).replace('.', ',')
}
